import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { IFollowUpState, FollowUpTypes } from './types'
import { IActionType, success, failure, request, IPaginator, ISearch } from '../root.types'
import { FollowUp } from '../../application/models/followUp/followUp'
const INITIAL_STATE: IFollowUpState = {
    create: {
        followUp: new FollowUp(),
        loading: false,
        success: false,
        error: false
    },
    list: {
        followUps: [],
        loading: false,
        error: false,
        success: false,
        paginator: {
            first: 0,
            rows: 5,
            page: 0,
            pageCount: 0,
            totalRecords: 0,
            search: {
                key: '',
                value: ''
            }
        }
    },
    stepper: 0,
    stepperTwo: 0,


}
// reducers para identificar em cada etapa esta
export const handleStepper = (state: IFollowUpState = INITIAL_STATE, action: IActionType<{ step: number }>) => {
    const { step } = action.payload
    return {
        ...state, stepper: step
    }
}

export const handleNextStepperTwo = (state: IFollowUpState = INITIAL_STATE, action: IActionType<{ step: number }>) => {
    const { step } = action.payload
    return {
        ...state, stepperTwo: step
    }
}

// reducers criar um followUp(acompanhamento)
export const createFollowUpRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ patientId: string }>) => {
    return { ...state, list: request({ ...state.list }) }
}
export const createFollowUpSuccess = (
    state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ data: FollowUp }>) => {
    const { data } = action.payload
    const updateList = [data].concat(state.list.followUps)
    return {
        ...state,
        create: { ...state.create, followUp: data },
        list: success({ ...state.list, followUps: updateList })
    }
}
export const createFollowUpFailure = (state: IFollowUpState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}
// reducers para carregar listagem dO ACOMPANHAMENTO
export const loadFollowUpRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ patientId: string, paginator: IPaginator, filter: ISearch }>) => {
    const { paginator } = action.payload
    return { ...state, list: request({ ...state.list, paginator }) }
}
export const loadFollowUpSuccess = (
    state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ data: FollowUp[], headers: any }>) => {
    const { data, headers } = action.payload

    const paginator = {
        ...state.list.paginator,
        totalRecords: parseInt(headers['x-total-count'], 10)
    }
    return {
        ...state,
        list: success({ ...state.list, followUps: data, paginator })
    }
}
export const loadFollowUpFailure = (state: IFollowUpState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}
// reducers para procura acompanhamento especifico
export const findFollowUpRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ patientId: string, followUpId: string }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const findFollowUpSuccess = (
    state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ data: FollowUp }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, followUp: data })
    }
}
export const findFollowUpFailure = (state: IFollowUpState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}
// reducers para atualizar dados do paciente 
/*export const updateFollowUpRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ followUp: FollowUp }>) => {
    return { ...state, create: request({ ...state.create }) }
}*/
export const updateFollowUpRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ followUp: FollowUp }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const updateFollowUpSuccess = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ data: FollowUp }>) => {
    const { data } = action.payload
    const updadedList = state.list.followUps.map((item) =>
        item.id === data.id ? data : item
    )

    return {
        ...state,
        create: success({ ...state.create, followUp: data }),
        list: { ...state.list, followUps: updadedList }
    }
}

export const updateFollowUpFailure = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ step }>) => {
    const { step } = action.payload
    return {
        ...state,
        create: failure({ ...state.create, step: step - 1 })
    }
}
// reducers para buscar followup para alerta 
export const followUpAlertRequest = (state: IFollowUpState = INITIAL_STATE,
    action: IActionType<{ date: string, paginator: IPaginator }>) => {
    return { ...state, create: request({ ...state.create }) }
}
const reducer: Reducer<IFollowUpState> = createReducer<IFollowUpState>(INITIAL_STATE, {
    [FollowUpTypes.HANDLE_STEPPER]: handleStepper,
    [FollowUpTypes.HANDLE_STEPPER_TWO]: handleNextStepperTwo,
    [FollowUpTypes.CREATE_FOLLOWUP_REQUEST]: createFollowUpRequest,
    [FollowUpTypes.CREATE_FOLLOWUP_SUCCESS]: createFollowUpSuccess,
    [FollowUpTypes.CREATE_FOLLOWUP_FAILURE]: createFollowUpFailure,
    [FollowUpTypes.FIND_FOLLOWUP_REQUEST]: findFollowUpRequest,
    [FollowUpTypes.FIND_FOLLOWUP_SUCCESS]: findFollowUpSuccess,
    [FollowUpTypes.FIND_FOLLOWUP_FAILURE]: findFollowUpFailure,
    [FollowUpTypes.LOAD_FOLLOWUP_REQUEST]: loadFollowUpRequest,
    [FollowUpTypes.LOAD_FOLLOWUP_SUCCESS]: loadFollowUpSuccess,
    [FollowUpTypes.LOAD_FOLLOWUP_FAILURE]: loadFollowUpFailure,
    [FollowUpTypes.UPDATE_FOLLOWUP_REQUEST]: updateFollowUpRequest,
    [FollowUpTypes.UPDATE_FOLLOWUP_SUCCESS]: updateFollowUpSuccess,
    [FollowUpTypes.UPDATE_FOLLOWUP_FAILURE]: updateFollowUpFailure,
})
export default reducer    